import React, { useEffect, useState } from "react";
import { OPERTIONS_URL } from "../../../../common/common";
import { ApiService } from "../../../../service/api.service";
import { booking } from "../../../../common/svg";
import { useNavigate } from "react-router-dom";

interface BookingDetailsProps {
  id: any;
}

const BookingDetails: React.FC<BookingDetailsProps> = ({ id }) => {
  const apiService = new ApiService();
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState<any>({});
  const [bookingDetail, setBookingDetail] = useState<any>({});
  const [tripDetail, setTripDetail] = useState<any>({});
  const [clientData, setClientData] = useState<any>({});
  const [companyData, setCompanyData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [executiveData, setExecutiveData] = useState<any>({});

  const getBookingData = async () => {
    try {
      setLoading(true);
      const response: any = await apiService.getApi(
        `${OPERTIONS_URL}/trip/details-route?tripId=${id}`
      );

      if (
        response.status === "200" &&
        Array.isArray(response.body) &&
        response.body.length > 0 &&
        typeof response.body[0] === "object"
      ) {
        const data = response.body[0];

        const bookingDetail = data?.bookingDetail || {};
        const tripDetail = data?.tripDetail || {};
        const clientDetail = data?.clientDetail || {};
        const companyDetail = data?.companyDetail || {};
        const executiveDetail = data?.executiveDetail || {};

        setBookingData(bookingDetail);
        setBookingDetail(bookingDetail);
        setTripDetail(tripDetail);
        setClientData(clientDetail);
        setCompanyData(companyDetail);
        setExecutiveData(executiveDetail);
      } else {
        setBookingData({});
        setBookingDetail({});
        setTripDetail({});
        setClientData({});
        setCompanyData({});
        setExecutiveData({});
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
      setBookingData({});
      setBookingDetail({});
      setTripDetail({});
      setClientData({});
      setCompanyData({});
      setExecutiveData({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getBookingData();
    }
  }, [id]);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }
  console.log("Booking Data:", companyData, executiveData);
  return (
    <div className="w-full  flex flex-wrap gap-1">
      {/* Booking Section */}
      <div className="flex flex-col min-w-[130px] text-left">
        <p className="text-gray-500 font-semibold text-sm">Booking</p>
        <button
          className="text-[#444FBD] text-left font-medium text-sm hover:underline"
          onClick={() => navigate(`/booking/view/${bookingDetail?.bookingId}`)}
        >
          {bookingDetail?.bookingName || "N/A"}
        </button>
        <p className="text-sm text-gray-800">#{bookingDetail?.bookingNumber || "N/A"}</p>
      </div>

      {/* Type Section */}
      <div className="flex flex-col min-w-[130px] text-left">
        <p className="text-gray-500 font-semibold text-sm">Type</p>
        <p className="text-sm font-medium text-gray-800">{bookingData?.bookingType || "Export"}</p>
        <p className="text-sm text-gray-800">{bookingData?.serviceType || "Direct Drop"}</p>
      </div>

      {/* Eway Bill Section */}
      <div className="flex flex-col min-w-[130px] text-left">
        <p className="text-gray-500 font-semibold text-sm">Eway Bill</p>
        <p className="text-sm font-medium text-gray-800">{tripDetail.eWayBill || "N/A"}</p>
        <p className="text-sm text-gray-800">LR {tripDetail.lrNumber || "N/A"}</p>
      </div>

      {/* Client Section */}
      <div className="flex flex-col min-w-[130px] text-left">
        <p className="text-gray-500 font-semibold text-sm">Client</p>
        <button
          className="text-[#444FBD] font-medium text-left text-sm hover:underline"
          onClick={() => navigate(`/client/view/${companyData?.clientId}`)}
        >
          {executiveData?.firstName || executiveData?.lastName
            ? `${executiveData.firstName || ""} ${executiveData.lastName || ""}`.trim()
            : "N/A"}
        </button>
        <p className="text-sm text-gray-800">{executiveData?.phoneNumber || "N/A"}</p>
      </div>

      {/* Company Section */}
      <div className="flex flex-col min-w-[130px] text-left">
        <p className="text-gray-500 font-semibold text-sm">Company</p>
        <button
          className="text-[#444FBD] text-left font-medium text-sm hover:underline"
          onClick={() => navigate(`/client/view/${companyData?.clientId}`)}
        >
          {companyData?.companyName || "N/A"}
        </button>
        <p className="text-sm text-gray-800">
          {companyData?.state || "N/A"}, {companyData?.city || ""}
        </p>
      </div>
    </div>

  );
};

export default BookingDetails;
